import React from 'react';
import { Oval, ProgressBar } from 'react-loader-spinner';
import { TColorRole, colorMap } from '../../../types/types';
import { TextCustom } from '../../ui/TextCustom';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';

interface ILoaderProps {
    height?: number;
    width?: number;
    strokeWidth?: number;
    strokeWidthSecondary?: number;
    color?: TColorRole;
    label?: string;
    gap?: number;
    textColor?: TColorRole;
    hasText?: boolean;
}

export const Loader: React.FC<ILoaderProps> = ({
    height = 15,
    width = 15,
    strokeWidth = 5,
    strokeWidthSecondary = 5,
    color = 'white',
    label = '',
    gap = 0.5,
    textColor = 'grey-dark',
    hasText = true,
}) => {
    const hexColor = colorMap[color] || colorMap['white'];

    const ovalAndText = (
        <>
            <Oval visible={true} height={height} width={width} strokeWidth={strokeWidth} strokeWidthSecondary={strokeWidthSecondary} color={hexColor} secondaryColor={hexColor} />{' '}
            {hasText && (
                <TextCustom size={1} color={textColor}>
                    {label}
                </TextCustom>
            )}
        </>
    );

    return <FlexCenter gap={gap}>{ovalAndText}</FlexCenter>;
};
